module.exports = __webpack_public_path__ + "img/warning-red.ff3bc07f.svg";